import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { FetchLinkResetDigestParams } from 'api/LinkResetDigestApi';
import { linkResetDigestApi } from 'container/linkResetDigestApi';

import { STORE_NAME } from './initialState';

export const fetchLinkResetDigest = createAsyncThunk(
  `${STORE_NAME}/fetchLinkResetDigest`,
  (params: FetchLinkResetDigestParams) => {
    return linkResetDigestApi.fetchDigest(params);
  },
  { serializeError },
);

export const fetchDigestEmailPreference = createAsyncThunk(
  `${STORE_NAME}/fetchDigestEmailPreference`,
  () => {
    return linkResetDigestApi.fetchNotificationPreference();
  },
  { serializeError },
);

export const saveDigestEmailPreference = createAsyncThunk(
  `${STORE_NAME}/saveDigestEmailPreference`,
  (enabled: boolean) => {
    return linkResetDigestApi.updateNotificationPreference(enabled);
  },
  { serializeError },
);
